<script>
    import { push, replace } from "svelte-spa-router";
    import SaaltextSliderItem from "./SaaltextSliderItem.svelte";

    export let saalheftId;
    export let saals = [];
</script>

<div class="saaltext-slider">
    <div class="saaltext-wrapper">
        {#each saals as saal, index}
            <SaaltextSliderItem
                saal= {saal} , saalNumber= {index + 1}
                on:click={replace(`/saaltext/${saalheftId}/${saal.id}`)}
            />
            {#if index !== saals.length - 1}
                <div class="divider-v slider-divider" />
            {/if}
        {/each}
    </div>
</div>

<style>
    .saaltext-wrapper {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 100%;
        margin: 0 -16px 0 0px;
    }

    .saaltext-slider {
        margin: 16px 0px;
        padding: 16px 0px 16px 8px;
        overflow-x: auto;
        white-space: nowrap;
        -ms-overflow-style: none;
        scrollbar-width: none;
        align-items: stretch;
    }

    /* Hide scrollbar for Chrome, Safari and Opera */
    .saaltext-slider::-webkit-scrollbar {
        display: none;
    }

    .slider-divider {
        margin: 0px 8px 0px 8px;
        align-self: stretch;
        height: auto;
        min-width: 1px;
    }

    @media only screen and (min-width: 1440px) {
        .slider-divider {
            margin: 0px 24px 0px 24px;
        }
        .saaltext-slider {
            padding: 0 0 0 24px;
            margin: 0px;
        }
    }
</style>
